//Ambiente di development da mettere online
export const environment = {
  production: false,
  testing: false,
  stage: "",
  version:'1.1'
};

export const api = {
  // baseUrl: "http://192.168.1.69:3307",
  // socketUrl: "http://192.168.1.69:3000",
  baseUrl: "https://api-quizzotic-dev.adpl.it",
  socketUrl: "https://ws-quizzotic-dev.adpl.it",
  prefixAuthorization: "Bearer",
  endpoint: {
    login: "/auth/login",
    recovery: "/recovery-password",
    sendEmailRecovery: "/auth/send-email",
    me: "/user/me",
    changePassword: "/auth/change-password",
    refreshToken: "/auth/refresh",
    register: "/auth/register",
  },
};
